import dayjs from 'dayjs'

export const CATEGORY_UNITS = {electricity: 'kWh', water: 'm³', gas: 'm³'}
export const DEFAULT_CATEGORY = 'electricity'

export const getUnit = (category) => CATEGORY_UNITS[category] || ''

export const formatNumber = (value, digits = 0) =>
    Number(value || 0).toLocaleString(undefined, {maximumFractionDigits: digits})

export const formatMoney = (value) => `${formatNumber(value)} ₪`

// null when there is nothing meaningful to compare against.
export const percentChange = (current, previous) =>
    previous > 0 ? ((current - previous) / previous) * 100 : null

// Deep links into the list pages. The tables read their filters from the URL, so a link is just
// the page path plus the filter params the list already understands.
export const buildListLink = (path, params) => `${path}?${new URLSearchParams(params)}`

export const todayRange = () => {
    const today = dayjs().format('YYYY-MM-DD')
    return {from_date: today, to_date: today}
}
